import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Divider,
  Button,
} from "@mui/material";

import "leaflet/dist/leaflet.css";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

import L from "leaflet";

const icon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const border = "1px solid #dcdcdc";

const label = {
  fontWeight: 600,
};

const sectionHeader = {
  backgroundColor: "#f3f6f9",
  fontWeight: 700,
};

const SelfieSection = ({ data }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState("");

  const handleOpenLightbox = (img) => {
    setLightboxImage(img);
    setLightboxOpen(true);
  };

  const handleCloseLightbox = () => {
    setLightboxImage("");
    setLightboxOpen(false);
  };

  useEffect(() => {
    const esc = (e) => {
      if (e.key === "Escape") {
        handleCloseLightbox();
      }
    };

    document.addEventListener("keydown", esc);

    return () => {
      document.removeEventListener("keydown", esc);
    };
  }, []);

  const handleViewMap = (lat, lng) => {
    if (lat && lng) {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,
        "_blank",
      );
    }
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Card elevation={3}>
        <Box
          sx={{
            background: "linear-gradient(135deg,#283e51 0%,#4b79a1 100%)",
            color: "#fff",
            py: 2,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            Assessor Selfie & Location Verification
          </Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table size="small">
            <TableBody>
              {data?.map((item, index) => (
                <React.Fragment key={index}>
                  <TableRow sx={sectionHeader}>
                    <TableCell colSpan={3} sx={border}>
                      Assessment Details
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ border, ...label }}>
                      Laboratory
                      <Typography variant="body2">
                        {item.LaboratoryName}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ border, ...label }}>
                      Assessor
                      <Typography variant="body2">
                        {item.Name}
                        {item.Capacity && ` (${item.Capacity})`}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ border, ...label }}>
                      Date(s) of Visit
                      <Typography variant="body2">{item.DateFrom}</Typography>
                    </TableCell>
                  </TableRow>

                  {/* START */}

                  <TableRow sx={sectionHeader}>
                    <TableCell colSpan={3} sx={border}>
                      Start Details
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ border }}>
                      <strong>Start Date</strong>

                      <Typography variant="body2">{item.StartDate}</Typography>
                    </TableCell>

                    <TableCell sx={{ border }}>
                      <strong>Start Selfie</strong>

                      {item.StartSelfie && (
                        <Box
                          sx={{
                            mt: 1,
                            cursor: "pointer",
                          }}
                          onClick={() => handleOpenLightbox(item.StartSelfie)}
                        >
                          <img
                            src={item.StartSelfie}
                            alt=""
                            style={{
                              height: 180,
                              borderRadius: 6,
                              border: "1px solid #ccc",
                            }}
                          />
                        </Box>
                      )}
                    </TableCell>

                    <TableCell sx={{ border }}>
                      <strong>Start Location</strong>

                      {item.StartLat && item.StartLong && (
                        <>
                          <MapContainer
                            center={[
                              parseFloat(item.StartLat),
                              parseFloat(item.StartLong),
                            ]}
                            zoom={13}
                            style={{
                              height: "180px",
                              width: "100%",
                              marginTop: 8,
                            }}
                          >
                            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                            <Marker
                              icon={icon}
                              position={[
                                parseFloat(item.StartLat),
                                parseFloat(item.StartLong),
                              ]}
                            >
                              <Popup>Start Location</Popup>
                            </Marker>
                          </MapContainer>
                          <Button
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1 }}
                            onClick={() =>
                              handleViewMap(item.StartLat, item.StartLong)
                            }
                          >
                            View on Map
                          </Button>
                        </>
                      )}
                    </TableCell>
                  </TableRow>

                  {/* STOP */}

                  <TableRow sx={sectionHeader}>
                    <TableCell colSpan={3} sx={border}>
                      Stop Details
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ border }}>
                      <strong>Stop Date</strong>

                      <Typography variant="body2">{item.StopDate}</Typography>
                    </TableCell>

                    <TableCell sx={{ border }}>
                      <strong>Stop Selfie</strong>

                      {item.StopSelfie && (
                        <Box
                          sx={{
                            mt: 1,
                            cursor: "pointer",
                          }}
                          onClick={() => handleOpenLightbox(item.StopSelfie)}
                        >
                          <img
                            src={item.StopSelfie}
                            alt=""
                            style={{
                              height: 180,
                              borderRadius: 6,
                              border: "1px solid #ccc",
                            }}
                          />
                        </Box>
                      )}
                    </TableCell>

                    <TableCell sx={{ border }}>
                      <strong>Stop Location</strong>

                      {item.StopLat && item.StopLong && (
                        <>
                          <MapContainer
                            center={[
                              parseFloat(item.StopLat),
                              parseFloat(item.StopLong),
                            ]}
                            zoom={13}
                            style={{
                              height: "180px",
                              width: "100%",
                              marginTop: 8,
                            }}
                          >
                            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                            <Marker
                              icon={icon}
                              position={[
                                parseFloat(item.StopLat),
                                parseFloat(item.StopLong),
                              ]}
                            >
                              <Popup>Stop Location</Popup>
                            </Marker>
                          </MapContainer>
                          <Button
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1 }}
                            onClick={() =>
                              handleViewMap(item.StopLat, item.StopLong)
                            }
                          >
                            View on Map
                          </Button>
                        </>
                      )}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={3} sx={{ p: 0 }}>
                      <Divider sx={{ my: 2 }} />
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      {lightboxOpen && (
        <Box
          onClick={handleCloseLightbox}
          sx={{
            position: "fixed",
            inset: 0,
            bgcolor: "rgba(0,0,0,0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img
            src={lightboxImage}
            alt=""
            style={{
              maxWidth: "90%",
              maxHeight: "90vh",
            }}
          />

          <Button
            variant="contained"
            onClick={handleCloseLightbox}
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
            }}
          >
            Close
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default SelfieSection;

// import React, { useEffect, useRef, useState } from "react";
// import {
//   Box,
//   Card,
//   Typography,
//   TableContainer,
//   Table,
//   TableBody,
//   TableCell,
//   TableRow,
//   Paper,
//   Divider,
//   Button,
//   alpha
// } from "@mui/material";

// const border = "1px solid #dcdcdc";
// const label = { fontWeight: 600 };
// const sectionHeader = {
//   backgroundColor: "#f3f6f9",
//   fontWeight: 700
// };

// const SelfieSection = ({ data }) => {
//   const mapRefs = useRef([]);
  
//   // Lightbox state
//   const [lightboxOpen, setLightboxOpen] = useState(false);
//   const [lightboxImage, setLightboxImage] = useState("");

//   // Lightbox handlers
//   const handleOpenLightbox = (imageUrl) => {
//     setLightboxImage(imageUrl);
//     setLightboxOpen(true);
//   };

//   const handleCloseLightbox = () => {
//     setLightboxOpen(false);
//     setLightboxImage("");
//   };

//   // ESC key handler for lightbox
//   useEffect(() => {
//     const handleEscKey = (event) => {
//       if (event.key === "Escape" && lightboxOpen) {
//         handleCloseLightbox();
//       }
//     };

//     if (lightboxOpen) {
//       document.addEventListener("keydown", handleEscKey);
//     }

//     return () => {
//       document.removeEventListener("keydown", handleEscKey);
//     };
//   }, [lightboxOpen]);

//   useEffect(() => {
//     if (!window.google) {
//       const script = document.createElement("script");
//       script.src =
//         "https://maps.googleapis.com/maps/api/js?key=AIzaSyB9hCqoJqsL0ZnlnN-TPxIsNupihrl-kUQ";
//       script.async = true;
//       script.onload = initializeMaps;
//       document.head.appendChild(script);
//     } else {
//       initializeMaps();
//     }
//   }, [data]);

//   const initializeMaps = () => {
//     if (!window.google || !data) return;

//     data.forEach((item, index) => {
//       if (item.StartLat && item.StartLong && mapRefs.current[`start-${index}`]) {
//         const map = new window.google.maps.Map(
//           mapRefs.current[`start-${index}`],
//           {
//             center: {
//               lat: parseFloat(item.StartLat),
//               lng: parseFloat(item.StartLong)
//             },
//             zoom: 11
//           }
//         );

//         new window.google.maps.Marker({
//           position: {
//             lat: parseFloat(item.StartLat),
//             lng: parseFloat(item.StartLong)
//           },
//           map
//         });
//       }

//       if (item.StopLat && item.StopLong && mapRefs.current[`stop-${index}`]) {
//         const map = new window.google.maps.Map(
//           mapRefs.current[`stop-${index}`],
//           {
//             center: {
//               lat: parseFloat(item.StopLat),
//               lng: parseFloat(item.StopLong)
//             },
//             zoom: 11
//           }
//         );

//         new window.google.maps.Marker({
//           position: {
//             lat: parseFloat(item.StopLat),
//             lng: parseFloat(item.StopLong)
//           },
//           map
//         });
//       }
//     });
//   };

//   return (
//     <Box sx={{ mb: 4 }}>
//       <Card elevation={3}>
//         {/* SECTION TITLE */}
//         <Box
//           sx={{
//             background:
//               "linear-gradient(135deg, #283e51 0%, #4b79a1 100%)",
//             color: "#fff",
//             py: 2,
//             textAlign: "center"
//           }}
//         >
//           <Typography variant="h6" fontWeight={700}>
//             Assessor Selfie & Location Verification
//           </Typography>
//         </Box>

//         <TableContainer component={Paper}>
//           <Table size="small">
//             <TableBody>
//               {data.map((item, index) => (
//                 <React.Fragment key={index}>
//                   {/* BASIC INFO */}
//                   <TableRow sx={sectionHeader}>
//                     <TableCell colSpan={3} sx={border}>
//                       Assessment Details
//                     </TableCell>
//                   </TableRow>

//                   <TableRow>
//                     <TableCell sx={{ border, ...label }}>
//                       Laboratory
//                       <Typography variant="body2">
//                         {item.LaboratoryName}
//                       </Typography>
//                     </TableCell>

//                     <TableCell sx={{ border, ...label }}>
//                       Assessor
//                       <Typography variant="body2">
//                         {item.Name}{" "}
//                         {item.Capacity && `(${item.Capacity})`}
//                       </Typography>
//                     </TableCell>

//                     <TableCell sx={{ border, ...label }}>
//                       Date(s) of Visit
//                       <Typography variant="body2">
//                         {item.DateFrom}
//                       </Typography>
//                     </TableCell>
//                   </TableRow>

//                   {/* START */}
//                   <TableRow sx={sectionHeader}>
//                     <TableCell colSpan={3} sx={border}>
//                       Start Details
//                     </TableCell>
//                   </TableRow>

//                   <TableRow sx={{ pageBreakInside: "avoid" }}>
//                     <TableCell sx={{ border }}>
//                       <strong>Start Date</strong>
//                       <Typography variant="body2">
//                         {item.StartDate}
//                       </Typography>
//                     </TableCell>

//                     <TableCell sx={{ border }}>
//                       <strong>Start Selfie</strong>
//                       {item.StartSelfie && (
//                         <Box 
//                           sx={{ 
//                             mt: 1,
//                             cursor: "pointer",
//                             transition: "all 0.2s",
//                             "&:hover": {
//                               opacity: 0.8,
//                               transform: "scale(1.02)",
//                             }
//                           }}
//                           onClick={() => handleOpenLightbox(item.StartSelfie)}
//                         >
//                           <img
//                             src={item.StartSelfie}
//                             alt="Start Selfie"
//                             style={{
//                               height: 180,
//                               borderRadius: 6,
//                               border: "1px solid #ccc"
//                             }}
//                           />
//                         </Box>
//                       )}
//                     </TableCell>

//                     <TableCell sx={{ border }}>
//                       <strong>Start Location</strong>
//                       <Box
//                         ref={(el) =>
//                           (mapRefs.current[`start-${index}`] = el)
//                         }
//                         sx={{
//                           width: "100%",
//                           height: 180,
//                           mt: 1,
//                           border: "1px solid #ccc",
//                           borderRadius: 1
//                         }}
//                       />
//                     </TableCell>
//                   </TableRow>

//                   {/* STOP */}
//                   <TableRow sx={sectionHeader}>
//                     <TableCell colSpan={3} sx={border}>
//                       Stop Details
//                     </TableCell>
//                   </TableRow>

//                   <TableRow sx={{ pageBreakInside: "avoid" }}>
//                     <TableCell sx={{ border }}>
//                       <strong>Stop Date</strong>
//                       <Typography variant="body2">
//                         {item.StopDate}
//                       </Typography>
//                     </TableCell>

//                     <TableCell sx={{ border }}>
//                       <strong>Stop Selfie</strong>
//                       {item.StopSelfie && (
//                         <Box 
//                           sx={{ 
//                             mt: 1,
//                             cursor: "pointer",
//                             transition: "all 0.2s",
//                             "&:hover": {
//                               opacity: 0.8,
//                               transform: "scale(1.02)",
//                             }
//                           }}
//                           onClick={() => handleOpenLightbox(item.StopSelfie)}
//                         >
//                           <img
//                             src={item.StopSelfie}
//                             alt="Stop Selfie"
//                             style={{
//                               height: 180,
//                               borderRadius: 6,
//                               border: "1px solid #ccc"
//                             }}
//                           />
//                         </Box>
//                       )}
//                     </TableCell>

//                     <TableCell sx={{ border }}>
//                       <strong>Stop Location</strong>
//                       <Box
//                         ref={(el) =>
//                           (mapRefs.current[`stop-${index}`] = el)
//                         }
//                         sx={{
//                           width: "100%",
//                           height: 180,
//                           mt: 1,
//                           border: "1px solid #ccc",
//                           borderRadius: 1
//                         }}
//                       />
//                     </TableCell>
//                   </TableRow>

//                   <TableRow>
//                     <TableCell colSpan={3} sx={{ p: 0 }}>
//                       <Divider sx={{ my: 2 }} />
//                     </TableCell>
//                   </TableRow>
//                 </React.Fragment>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Card>

//       {/* Lightbox for image preview */}
//       {lightboxOpen && (
//         <Box
//           sx={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             bgcolor: 'rgba(0, 0, 0, 0.9)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             zIndex: 9999,
//             cursor: 'pointer'
//           }}
//           onClick={handleCloseLightbox}
//         >
//           <Box sx={{ maxWidth: '90%', maxHeight: '90%' }}>
//             <img
//               src={lightboxImage}
//               alt="Selfie Preview"
//               style={{
//                 maxWidth: '100%',
//                 maxHeight: '90vh',
//                 objectFit: 'contain'
//               }}
//             />
//           </Box>
//           <Button
//             variant="contained"
//             sx={{
//               position: 'absolute',
//               top: 20,
//               right: 20,
//               bgcolor: 'white',
//               color: 'black',
//               '&:hover': { bgcolor: 'grey.300' }
//             }}
//             onClick={handleCloseLightbox}
//           >
//             Close
//           </Button>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default SelfieSection;
